// extracted by mini-css-extract-plugin
module.exports = {"BasicRow":"BasicRow_BasicRow__uukKd","Linked":"BasicRow_Linked__E49Wu"};